module.exports = __webpack_public_path__ + "img/9788963860022.42daf016.jpg";